export function resize($img, maxWidth, maxHeight)
{
	if($img.height <= 1024 && $img.width <= 1024)
		return $img.src;

	let $canvas = document.createElement('canvas');
	let canvasCtx = $canvas.getContext('2d');

	var width = $img.width;
	var height = $img.height;

	if (width > height) {
		if (width > maxWidth) {
			height = height * (maxWidth / width);
			width = maxWidth;
		}
	} else {
		if (height > maxHeight) {
			width = width * (maxHeight / height);
			height = maxHeight;
		}
	}

	$canvas.width = width;
	$canvas.height = height;

	canvasCtx.drawImage($img, 0, 0, width, height)
	return $canvas.toDataURL()
}